var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrueicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 12C23.625 18.4219 18.375 23.625 12 23.625C5.57812 23.625 0.375 18.4219 0.375 12C0.375 5.625 5.57812 0.375 12 0.375C18.375 0.375 23.625 5.625 23.625 12ZM10.6406 18.1875L19.2656 9.5625C19.5469 9.28125 19.5469 8.76562 19.2656 8.48438L18.1875 7.45312C17.9062 7.125 17.4375 7.125 17.1562 7.45312L10.125 14.4844L6.79688 11.2031C6.51562 10.875 6.04688 10.875 5.76562 11.2031L4.6875 12.2344C4.40625 12.5156 4.40625 13.0312 4.6875 13.3125L9.5625 18.1875C9.84375 18.4688 10.3594 18.4688 10.6406 18.1875Z",
    fill: "#5CBE66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueicon);
export default __webpack_public_path__ + "static/media/trueicon.42dc98630dcd5423b43049dbed7874ea.svg";
export { ForwardRef as ReactComponent };